// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { Icon } from '@progress/kendo-vue-common';
import { cancelIcon, plusIcon } from '@progress/kendo-svg-icons';
/**
 * @hidden
 */
var DragClueVue2 = {
  data: function data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      innerText: '',
      status: 'cancel'
    };
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return this.visible && h("div", {
      "class": "k-header k-drag-clue",
      style: {
        display: 'block',
        position: 'absolute',
        zIndex: 20000,
        padding: '8px 12px',
        top: this.top + 'px',
        left: this.left + 'px'
      }
    }, [h(Icon, {
      name: this.status,
      attrs: this.v3 ? undefined : {
        name: this.status,
        icon: this.status === 'cancel' ? cancelIcon : plusIcon
      },
      "class": 'k-drag-status',
      icon: this.status === 'cancel' ? cancelIcon : plusIcon
    }), this.innerText]);
  }
};
/**
 * @hidden
 */
var DragClue = DragClueVue2;
export { DragClue, DragClueVue2 };